const boolOptions = [
  { label: 'True', id: true },
  { label: 'False', id: false },
]

export const viewableEventClasses = ['SMOKE', 'NOISE']

export default boolOptions
